'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var React = require('react');
var React__default = _interopDefault(React);
var adminPortal = require('@frontegg/admin-portal');
var reactHooks = require('@frontegg/react-hooks');
var restApi = require('@frontegg/rest-api');
var router = require('next/router');
var auth = require('@frontegg/react-hooks/auth');
var audits = require('@frontegg/react-hooks/audits');
var connectivity = require('@frontegg/react-hooks/connectivity');

var Connector = function (_a) {
    var _b;
    var router = _a.router, appName = _a.appName, props = tslib.__rest(_a, ["router", "appName"]);
    var isSSR = typeof window === 'undefined';
    // v6 or v5
    var baseName = (_b = props.basename) !== null && _b !== void 0 ? _b : router.basePath;
    var onRedirectTo = React.useCallback(function (_path, opts) {
        var path = _path;
        if (path.startsWith(baseName)) {
            path = path.substring(baseName.length);
        }
        if (opts === null || opts === void 0 ? void 0 : opts.preserveQueryParams) {
            path = "" + path + window.location.search;
        }
        if ((opts === null || opts === void 0 ? void 0 : opts.refresh) && !isSSR) {
            // @ts-ignore
            window.Cypress ? router.push(path) : (window.location.href = path);
        }
        else {
            (opts === null || opts === void 0 ? void 0 : opts.replace) ? router.replace(path) : router.push(path);
        }
    }, []);
    var app = React.useMemo(function () {
        return adminPortal.initialize(tslib.__assign(tslib.__assign({}, props), { contextOptions: tslib.__assign({ requestCredentials: 'include' }, props.contextOptions), onRedirectTo: onRedirectTo }), appName !== null && appName !== void 0 ? appName : 'default');
    }, [onRedirectTo]);
    restApi.ContextHolder.setOnRedirectTo(onRedirectTo);
    React.useEffect(function () { return function () {
        var _a, _b;
        try {
            (_b = (_a = app.store) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
        catch (e) { }
    }; }, []);
    return React__default.createElement(reactHooks.FronteggStoreProvider, tslib.__assign({}, tslib.__assign(tslib.__assign({}, props), { app: app })), props.children);
};
var FronteggProvider = function (props) {
    var router$1 = router.useRouter();
    return (React__default.createElement(Connector, tslib.__assign({}, props, { router: router$1 }), props.children));
};

var AuthorizedContent = function (props) {
    var _a, _b;
    var isAuthorized = true; // Initially
    var user = reactHooks.useAuthUserOrNull();
    if (!(user === null || user === void 0 ? void 0 : user.superUser)) {
        if (props.requiredPermissions) {
            if (!(user === null || user === void 0 ? void 0 : user.permissions) || (user === null || user === void 0 ? void 0 : user.permissions.length) === 0) {
                isAuthorized = false;
            }
            var _loop_1 = function (permission) {
                if (!((_a = user === null || user === void 0 ? void 0 : user.permissions) === null || _a === void 0 ? void 0 : _a.find(function (_a) {
                    var key = _a.key;
                    return key === permission;
                }))) {
                    isAuthorized = false;
                }
            };
            for (var _i = 0, _c = props.requiredPermissions; _i < _c.length; _i++) {
                var permission = _c[_i];
                _loop_1(permission);
            }
        }
        if (props.requiredRoles) {
            if (!(user === null || user === void 0 ? void 0 : user.roles) || (user === null || user === void 0 ? void 0 : user.roles.length) === 0) {
                isAuthorized = false;
            }
            var _loop_2 = function (role) {
                if (!((_b = user === null || user === void 0 ? void 0 : user.roles) === null || _b === void 0 ? void 0 : _b.find(function (_a) {
                    var key = _a.key;
                    return key === role;
                }))) {
                    isAuthorized = false;
                }
            };
            for (var _d = 0, _e = props.requiredRoles; _d < _e.length; _d++) {
                var role = _e[_d];
                _loop_2(role);
            }
        }
    }
    if (typeof props.render === 'function') {
        return React__default.createElement(React__default.Fragment, null, props.render(isAuthorized));
    }
    return isAuthorized ? React__default.createElement(React__default.Fragment, null, props.children) : null;
};

Object.keys(auth).forEach(function (k) {
  if (k !== 'default') Object.defineProperty(exports, k, {
    enumerable: true,
    get: function () {
      return auth[k];
    }
  });
});
Object.keys(audits).forEach(function (k) {
  if (k !== 'default') Object.defineProperty(exports, k, {
    enumerable: true,
    get: function () {
      return audits[k];
    }
  });
});
Object.keys(connectivity).forEach(function (k) {
  if (k !== 'default') Object.defineProperty(exports, k, {
    enumerable: true,
    get: function () {
      return connectivity[k];
    }
  });
});
Object.defineProperty(exports, 'AdminPortal', {
  enumerable: true,
  get: function () {
    return adminPortal.AdminPortal;
  }
});
exports.AuthorizedContent = AuthorizedContent;
exports.Connector = Connector;
exports.FronteggProvider = FronteggProvider;
//# sourceMappingURL=index.js.map
